// extracted by mini-css-extract-plugin
export var big = "e_B_bT";
export var button = "e_B_bQ";
export var disabled = "e_B_C";
export var fullWidth = "e_B_bX";
export var medium = "e_B_bS";
export var normal = "e_B_bV";
export var outline = "e_B_bW";
export var small = "e_B_bR";